import { Component, Prop, Vue } from 'vue-property-decorator';
import { FormWrapperLayoutModel } from './FormWrapper.type';
import { FormWrapperLayoutType } from './FormWrapper.type';

const FormWrapperProps = Vue.extend({
  props: {
    layout: {
      type: String as () => FormWrapperLayoutType,
      required: false,
      default: FormWrapperLayoutModel.Standard,
      validator: (input) => {
        return ['Standard', 'Half', 'TwoThirds', 'TwoColumnsLayout', 'Full'].includes(input);
      },
    },
    insertAsCol: {
      type: Boolean,
      default: false,
      required: false,
    },
    setBackground: {
      type: String,
      default: null,
      required: false,
    },
  },
});

@Component({})
export default class FormWrapper extends FormWrapperProps {
  classList = {
    Standard: 'lex-col--size-12 lex-col-md--size-8 lex-col-xl--size-6',
    Half: 'lex-col--size-12 lex-col-md--size-8 lex-col-lg--size-12',
    TwoThirds: 'lex-col--size-12  lex-col-xl--size-9',
    TwoColumnsLayout: 'lex-col--size-12  lex-col-xl--size-8',
    Full: 'lex-col--size-12',
  };
}
